import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {useGetAbtestParametersQuery} from "../../../core/reducers/abtest";
import {getEnvName} from "../../Utils/CommonUtils";
import AudienceEditor from "../../Audience/AudienceEditor";
import {AUDIENCE_VARIANTS} from "../../Audience/audienceEditorModel";
import {useTypeAbbreviations} from "../../Campaign/CampaignSteps/AudienceStep";

// раньше здесь была своя копия карты операторов — теперь общая
export {POSSIBLE_OPERATORS} from "../../Campaign/campaignFormModel";

/**
 * Шаг "audience" AB-теста: тот же редактор, что и у кампаний, с особенностями AB
 * (параметры из AB API, ab_test — одно значение, когорты фильтруются по выбранному AB-тесту, без repeatable).
 */
export default function AudienceStep(props) {
    const sourceMode = useSelector((state) => state.data.SourceMode);
    const [searchParams] = useSearchParams();
    const env = getEnvName('env', sourceMode, searchParams);
    const paramsQuery = useGetAbtestParametersQuery({env});
    const abbreviations = useTypeAbbreviations();

    return (
        <AudienceEditor
            item={props.currentAbTest}
            setItem={props.setCurrentAbTest}
            handlers={props}
            params={paramsQuery.data}
            paramsQuery={paramsQuery}
            variant={AUDIENCE_VARIANTS.abtest}
            abbreviations={abbreviations}
            errorAudienceIndexes={props.errorAudienceIndexes}
            errorFields={props.errorFields}
            showRepeatable={false}
        />
    );
}
